import React from 'react'
import Header from '../_components/common/Header'
import NotificationMngUI from '../_components/UI/NotificationMngUI'

const NotificationMng = () => {
  return (
    <div className='page-main'>
        <Header name = {["Notification Management"]}/>
        <NotificationMngUI />

    </div>
  )
}

export default NotificationMng